/**
 * Question World Module - Constants
 * Self-contained constants for the question_world module
 */

// Environment-based URLs
export const bucket_url = process.env.REACT_APP_ASSET_URL || 'https://assets.retinalms.com/';
export const bucket_url_old = 'https://assets.retinabd.site/';
export const base_url = localStorage.getItem('baseUrl') || process.env.REACT_APP_BASE_URL;

// Radio option labels for MCQ/MCA questions
export const radioLabels = {
    0: 'A',
    1: 'B',
    2: 'C',
    3: 'D',
    4: 'E',
    5: 'F',
    6: 'G',
    7: 'H',
    8: 'I',
    9: 'J',
    10: 'K'
};

// MCA possible options
export const MCA_OPTIONS = ['true', 'false'];

// Question types
export const QUESTION_TYPES = {
    MCQ: 'MCQ',
    MCA: 'MCA',
    CHECKBOX: 'checkbox',
    SHORT_ANS: 'shortAns',
    PARAGRAPH: 'paragraph'
};

// Brand color for Question World
export const BRAND_COLOR = '#662d91';

// Exam status constants
export const examStatus = {
    SCHEDULED: 'scheduled',
    UNPUBLISHED: 'unpublished',
    PUBLISHED: 'published',
    CREATED: 'created',
    ENDED: 'ended',
    RESULT_PUBLISHED: 'resultPublished'
};

